import { useRouter } from 'next/router'
import { useCallback } from 'react'

export const useDealSyncAuthHandler = () => {
  const router = useRouter()

  const { query } = router

  const handleDealSyncAuthParam = useCallback(() => {
    if (query?.dealSyncLogin) {
      localStorage.setItem('dealSyncLogin', 'true')
    }
  }, [query])

  const isDealSyncLogin = useCallback(() => {
    return localStorage.getItem('dealSyncLogin') === 'true'
  }, [])

  const clearDealSyncLogin = useCallback(() => {
    localStorage.removeItem('dealSyncLogin')
  }, [])

  return {
    handleDealSyncAuthParam,
    isDealSyncLogin,
    clearDealSyncLogin,
  }
}
